import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

interface FeatureGuardProps {
  children: ReactNode;
  featureEnabled: boolean;
  featureName?: string;
  redirectTo?: string;
  loading?: boolean;
}

export function FeatureGuard({
  children,
  featureEnabled,
  redirectTo = '/',
  loading = false
}: FeatureGuardProps) {
  // During loading, render children to avoid premature redirects
  // The actual feature check will happen once config is loaded
  if (loading) {
    return <>{children}</>;
  }

  if (!featureEnabled) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
}
